import { GA4EventHandlers } from '../../hooks'
import { IdDocumentValidation_ViewerFragment } from './__generated__/id-document-validation.graphql'
import { SharedDataInterface } from './context'
import { Steps } from './enums'
import {
  DocumentCpfInUse,
  DocumentError,
  DocumentPreview,
  IdentityError,
  IdentitySuccess,
  RemovalCpfEmail,
  ValidateDocument,
  ValidatingDocument,
} from './steps'
import { IdDocumentValidationEventData, IdDocumentValidationTexts } from './types'

interface StepFuncProps {
  viewer: IdDocumentValidation_ViewerFragment | null
  onClose?: () => void
  sharedData?: SharedDataInterface
  setSharedData?: (data: SharedDataInterface) => void
  eventData?: IdDocumentValidationEventData
  stepsCallback?: (isValidatedSuccess: boolean) => void
  gA4EventHandlers?: GA4EventHandlers
  texts?: IdDocumentValidationTexts
}

type StepFunc = (props: StepFuncProps) => React.ReactNode

export const FLOW_STEPS: Record<Steps, StepFunc> = {
  [Steps.VALIDATE_DOCUMENT]: ({ gA4EventHandlers }) => (
    <ValidateDocument gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.DOCUMENT_PREVIEW]: () => <DocumentPreview />,
  [Steps.VALIDATING_DOCUMENT]: ({ stepsCallback, gA4EventHandlers }) => (
    <ValidatingDocument validateCallback={stepsCallback} gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.DOCUMENT_ERROR]: ({ gA4EventHandlers }) => (
    <DocumentError gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.IDENTITY_SUCCESS]: ({ onClose, gA4EventHandlers }) => (
    <IdentitySuccess onClose={onClose} gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.CPF_IN_USE]: () => <DocumentCpfInUse />,
  [Steps.REMOVAL_CPF_EMAIL]: ({ onClose, gA4EventHandlers }) => (
    <RemovalCpfEmail onClose={onClose} gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.IDENTITY_ERROR]: ({ gA4EventHandlers }) => (
    <IdentityError gA4EventHandlers={gA4EventHandlers} />
  ),
}
